<template>
<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<a href="https://youtu.be/wq1_jMnQrys" target="_blank" class="downloadInfo is-pointer" style="line-height: 14px;">
		<span class="icon is-small"><i class="icon-ak-info"></i></span>
		<span>Anleitung zur Nutzung [video]</span>
	</a>

    <div v-if="!isLoading" class="calendar">

		<transition name="fade" mode="out-in" appear>
			<div class="overlayLoader" v-if="isFetchingData">
				<loading-indicator :loading="true"></loading-indicator>
			</div>
		</transition>

		<div class="calendarHeader">

			<div class="calendarNavi">

				<span class="icon is-large prev" @click="nav(false)">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                </span>

                <span class="title"><template v-if="calendarView=='month'">{{ months[this.currentMonth] }}, </template>{{ currentYear }}</span>

                <span class="icon is-large next" @click="nav(true)">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>

			</div>

			<div class="calendarSwitcher">

				<button :class="[ { 'is-active': calendarView=='month' }, 'button is-small is-light']" @click="changeCalendarView('month')">
                    <span class="icon is-small">
                        <i class="fa fa-th" aria-hidden="true"></i>
                    </span>
                    Monat
                </button>

                <button :class="[ { 'is-active' : calendarView=='year' }, 'button is-small is-light']" @click="changeCalendarView('year')">
                    <span class="icon is-small">
                        <i class="fa fa-th-large" aria-hidden="true"></i>
                    </span>
                    Jahr
                </button>

			</div>

		</div>

        <div class="calendarBody">

            <!-- ROWS DEFAULT -->
			<div class="rows" v-for="(channels, key1, index) in events.DEFAULT" :key="channels">

				<!-- MAIN CATEGORIES -->
				<div class="row category">

					<div class="label has-pointer" @click="toggleCategory('DEFAULT', key1)">

						<span class="toggler icon is-small"><i :class="showCategory('DEFAULT', key1) ? 'icon-ak-unten' : 'icon-ak-vor'"></i></span>

						<template v-if="(['Administrator', 'Administrator JTM', 'HC Marketing'].indexOf(activeUser.userRole.name) > -1 && apoId == null) || (apoId != null && key1 == 'PHARMACYSERVICES')">

							<lang :labelKey="'MARKETING_CHANNEL_CATEGORY-'+key1"></lang> <span class="icon is-small" @click.stop="eventAdd('DEFAULT', key1)" title="neuen Termin anlegen"><i class="icon-ak-hinzufuegen"></i></span>

							<div class="labelAddChannel has-pointer" @click.stop="channelAdd(key1)" title="neue Maßnahme anlegen" v-if="key1 == 'PHARMACYSERVICES'">
								[ <lang labelKey="MARKETING_CHANNEL_CATEGORY-ADD_CHANNEL"></lang> <span class="icon is-smaller has-pointer"><i class="icon-ak-hinzufuegen"></i></span> ]
							</div>

						</template>

						<template v-else>

							<lang :labelKey="'MARKETING_CHANNEL_CATEGORY-'+key1"></lang>

						</template>

					</div>
					<div class="events"></div>

				</div>

				<template v-if="showCategory('DEFAULT', key1)">

					<div v-for="(channel, key2, index) in channels" :key="channel" :class="['row', { 'inactive': channel==null }]" :style="getRowHeight(key2)" v-if="showChannel(key1, key2)">

						<div class="label has-pointer">

							<template v-if="key1 == 'PHARMACYSERVICES'">

								<span class="labelEditable" @click="channelEdit(key1, key2)">
									{{ getChannelCustomizationName(key2) }}
									<span class="icon is-smaller"><i class="icon-ak-bearbeiten"></i></span>
								</span>
								<pop-confirm class="has-pointer" title="Channel löschen" content="Sind Sie sicher, dass Sie diesen Channel löschen wollen?" icon="question-circle-o" :on-ok="function() { channelDelete(key2) }" cancel-text="nein" ok-text="löschen">
									<span class="icon is-smaller"><i class="icon-ak-entfernen"></i></span>
								</pop-confirm>

							</template>

							<template v-else>

								<lang :labelKey="'TERM_MARKETING_CHANNELS-'+key2"></lang>

							</template>

							<template v-if="channel==null">

								<popover width="240" trigger="hover">

									<span class="icon is-small"><i class="fa fa-info-circle"></i></span>

									<div slot="content" class="labelPopover">
										<div class="title">{{ $t('TERM_MARKETING_CHANNELS-'+key2) }}</div>
										<span class="infoText" v-html="marketingChannels[key2].data.infoText"></span>
									</div>

								</popover>

							</template>

						</div>

						<div class="events">

							<template v-for="(event, index) in getEvents(channel, key2)" v-if="!isFetchingData">

								<!-- COMMON EVENT -->
								<transition name="fade" mode="out-in" appear>

									<popover width="320" trigger="click" :key="event.id">

										<div :class="['event', { inactive: channel == null }]" :style="getEventPosition(event, 'default')">
											<span class="eventTitle">{{ event.title }}</span>
										</div>

										<div slot="content" class="calendarPopover">

											<div class="block is-clearfix">

												<span class="date">

													<template v-if="event.startDate.split('T')[0] == event.endDate.split('T')[0]">
														{{ formatDate2(event.startDate, false) }}
													</template>

													<template v-else>
														{{ formatDate2(event.startDate, false) }} - {{ formatDate2(event.endDate, false) }}
													</template>

												</span>

												<div class="edit is-pulled-right" v-if="['Administrator', 'Administrator JTM', 'HC Marketing'].indexOf(activeUser.userRole.name) > -1 && channel != null || apoId != null && channel != null">

													<span class="icon is-small has-pointer" @click="eventEdit('DEFAULT', event)" title="bearbeiten"><i class="icon-ak-bearbeiten"></i></span>

													<template v-if="apoId != null && key1=='PHARMACYSERVICES'">
														<span class="icon is-small has-pointer" @click="eventCopy(key1, event)" title="kopieren"><i class="icon-ak-duplizieren"></i></span>
													</template>

													<template v-if="['Administrator', 'Administrator JTM', 'HC Marketing'].indexOf(activeUser.userRole.name) > -1 && apoId == null || (apoId != null && key1 == 'PHARMACYSERVICES') || (apoId != null && event.site != null)">
														<span class="icon is-small has-pointer" @click="eventDelete(event)" title="entfernen"><i class="icon-ak-entfernen"></i></span>
													</template>

												</div>

											</div>

											<div class="block is-clearfix">

												<span class="title">{{ event.title }}</span>
												<span class="description" v-if="event.description != null" v-html="nl2br(event.description)"></span>

											</div>

											<!-- show available todos (milestones) ...-->
											<div class="block tasks is-clearfix" v-if="event.tasks && event.tasks.length > 0">
												<span class="channel">{{ $t('CALENDAR-EVENT-POPOVER-TITLE-TODO') }}</span>
												<div v-for="task in event.tasks">
													<span class="taskDate">{{ formatDate2(task.deadline, false) }}</span>
													<span class="taskTitle">{{ task.title }}</span>
												</div>
											</div>

										</div>

									</popover>


								</transition>

								<!-- TODOS/TASKS -->
								<template v-for="task in event.tasks" v-if="event.tasks && event.tasks.length > 0 && inTimeSpan(task)">

									<popover width="320" trigger="click" :key="task.id">

										<span :class="['todo', { isOrange: task.site!=null }]" :style="getEventPosition(task, 'todo', event.row)"></span>

										<div slot="content" class="calendarPopover">

											<div class="block is-clearfix">
												<span class="date">{{ formatDate2(task.deadline, false) }}</span>
												<div class="edit is-pulled-right">
													<span class="icon is-small has-pointer" @click="eventEdit('DEFAULT', event)" title="bearbeiten" v-if="(['Administrator', 'Administrator JTM', 'HC Marketing'].indexOf(activeUser.userRole.name) > -1) || (apId != null && key1 == 'PHARMACYSERVICES')"><i class="icon-ak-bearbeiten"></i></span>
												</div>
											</div>

											<div class="block is-clearfix">
												<span class="channel">Event: {{ event.title }}</span>
												<span class="title">{{ task.title }}</span>
											</div>

										</div>

									</popover>

								</template>

							</template>

						</div>

					</div>

				</template>

			</div>


			<!-- ROWS "ALLGEMEINE TERMINE" (Feiertage etc.) -->
			<div class="rows" v-for="(channels, key, index) in events.SPECIAL_DATE" :key="key">

				<div class="row category">

					<div class="label has-pointer" @click="toggleCategory('SPECIAL_DATE', key)">

						<span class="toggler icon is-small"><i :class="showCategory('SPECIAL_DATE', key) ? 'icon-ak-unten' : 'icon-ak-vor'"></i></span>

						<template v-if="['Administrator', 'Administrator JTM', 'HC Marketing'].indexOf(activeUser.userRole.name) > -1 && apoId == null">

							<lang :labelKey="'MARKETING_CHANNEL_CATEGORY-'+key"></lang> <span class="icon is-small has-pointer" @click.stop="eventAdd('SPECIAL_DATE', key)" title="hinzufügen"><i class="icon-ak-hinzufuegen"></i></span>

						</template>

						<template v-else>

							<lang :labelKey="'MARKETING_CHANNEL_CATEGORY-'+key"></lang>

						</template>


					</div>

					<div class="events"></div>

				</div>

				<template v-if="showCategory('SPECIAL_DATE', key)">

					<div v-for="(channel, key, index) in channels" :key="key" class="row" :style="getRowHeight(key)">

						<div class="label">
							<lang :labelKey="'TERM_MARKETING_CHANNELS-'+key"></lang>
						</div>

						<div class="events">

							<template v-for="(event, eventIndex) in channel">

								<transition name="fade" appear>

									<popover width="320" trigger="click" v-if="!isFetchingData" :key="event.id">

										<div class="event" :style="getEventPosition(event, 'default')">
											<span class="eventTitle">{{ event.title }}</span>
										</div>

										<div slot="content" class="calendarPopover">

											<div class="block is-clearfix">

												<span class="date">
													<template v-if="event.startDate.split('T')[0] == event.endDate.split('T')[0]">
														{{ formatDate2(event.startDate, false) }}
													</template>

													<template v-else>
														{{ formatDate2(event.startDate, false) }} - {{ formatDate2(event.endDate, false) }}
													</template>
												</span>

												<div class="edit is-pulled-right" v-if="['Administrator', 'Administrator JTM', 'HC Marketing'].indexOf(activeUser.userRole.name) > -1 && apoId == null">
													<span class="icon is-small has-pointer" @click="eventEdit('SPECIAL_DATE', event)" title="bearbeiten"><i class="icon-ak-bearbeiten"></i></span>
													<span class="icon is-small has-pointer" @click="eventDelete(event)" title="entfernen"><i class="icon-ak-entfernen"></i></span>
												</div>
											</div>

											<div class="block is-clearfix">
												<span class="channel" v-if="event.marketingChannel != null">{{ $t('TERM_MARKETING_CHANNELS-'+event.marketingChannel.name) }}</span>
												<span class="title">{{ event.title }}</span>
											</div>

										</div>

									</popover>

								</transition>

							</template>

						</div>

					</div>
				</template>

			</div>



            <!-- COLS -->
            <div class="cols">

				<!-- MONTH View -->
                <template v-if="calendarView == 'month'">

                    <div v-for="n in currentDaysPerMonth" class="col day">

                        <div class="head">{{ n }}</div>
                        <div :class="[ { isWeekend: isDateHoliday(currentYear, currentMonth, n) }, 'body']"></div>

                    </div>

                </template>

				<!-- YEAR View -->
                <template v-else>

                    <div v-for="n in 12" class="col" :style="calculateColWidth(n)">

                        <div class="head has-pointer" @click="goToMonth(n)" :title="'Klick um zu Monat ' + months[n-1] + ' zu springen'">{{ monthsShort[n-1] }}</div>
                        <div class="body"></div>

                    </div>

                </template>

            </div>

			<!-- marker Position -->
			<template v-if="currentYear == date.getFullYear()">

				<template v-if="calendarView == 'month' && currentMonth == date.getMonth()">
					<div :style="getMarkerPosition('month')" class="currentDayMarker"></div>
				</template>
				<template v-else-if="calendarView == 'year'">
					<div :style="getMarkerPosition('year')" class="currentDayMarker"></div>
				</template>

			</template>

        </div> <!-- // calendarBody -->

        <modal
			:title="modal.title"
			:is-show="showModal"
			:backdrop-closable="false"
			transition="fadeDown"
			@close="closeModal(true)"
			ok-text="speichern"
			cancel-text="abbrechen"
			width="540"
			:class="['vcenter', modal.type]">


            <template v-if="activeEvent != null">

				<div style="margin: 0 auto; width: 98%;">

					<template v-if="modal.type=='eventAdd' || modal.type=='eventCopy'">

						<!-- pharmacy services should have a multi select for channels -->
						<template v-if="currentKey == 'PHARMACYSERVICES'">

							<div class="control">
								<div class="control-label">
									<label-name labelKey="CALENDAR-EVENT-TYP"></label-name>
								</div>
								<div class="control">

									<multiselect
										v-model="pharmacyServiceChannelsSelected"
										:options="pharmacyServiceChannels"
										label="name"
										deselect-label="Klick um abzuwählen"
						                selectLabel="Klick um auszuwählen"
										selectedLabel="ausgewählt"
										:placeholder="$t('SELECT_BOX-CPC-CATEGORY-PLEASE_SELECT')"
										:multiple="true"
										:close-on-select="true"
										:clear-on-select="false"
										:hide-selected="true"
										:preserve-search="false"
										track-by="id"
										class="singleSelect pharmacyServiceChannels">
									</multiselect>

								</div>
							</div>

						</template>

						<template v-else>

							<form-input inputType="select" label="CALENDAR-EVENT-TYP" minWidth="200px" :showLabelInOptions="true" :showLabel="true" :selectOptions="channels" v-model="marketingChannelSelected" :isHorizontal="false"></form-input>

						</template>


					</template>


					<template v-if="modal.type != 'eventCopy'">

						<template v-if="marketingChannelSelected != null && marketingChannelSelected.name == 'GALLERIA'">

							<template v-if="pharmaciesLoading">
								<loading-indicator-small class="small"></loading-indicator-small>
							</template>

							<template v-else>
								<!--
								<form-input inputType="select" label="CALENDAR-EVENT-PHARMACY" minWidth="200px" :showLabelInOptions="false" :showLabel="true" :selectOptions="optionsPharmacies" selectFieldName="displayName" :selectIsSearchable="true" v-model="selectedPharmacy" :isHorizontal="false"></form-input>
							-->





							<div class="control">
								<div class="control-label">
									<label-name labelKey="CALENDAR-EVENT-PHARMACY"></label-name>
								</div>
								<div class="control">
									<multiselect
										v-model="selectedPharmacies"
										:options="optionsPharmacies"
										label="displayName"
										deselect-label="Klick um abzuwählen"
										selectLabel="Klick um auszuwählen"
										selectedLabel="ausgewählt"
										:placeholder="$t('SELECT_BOX-USER-USERGROUP-PLEASE_SELECT')"
										:multiple="true"
										:close-on-select="true"
										:clear-on-select="false"
										:hide-selected="true"
										:preserve-search="false"
										track-by="name"
										class="tagging">
									</multiselect>
								</div>
							</div>

							</template>










						</template>

						<form-input inputType="text" label="CALENDAR-EVENT-TITLE" minWidth="200px" :showLabelInOptions="true" :showLabel="true" v-model="activeEvent.title" :isHorizontal="false" :isReadOnly="(apoId != null && currentKey != 'PHARMACYSERVICES')"></form-input>

		                <div class="control is-grouped" :key="activeEvent">

							<div class="control">
								<div class="control-label"><label-name labelKey="CALENDAR-EVENT-STARTDATE"></label-name></div>
								<div class="control">
									<flat-pickr placeholder="Startdatum" :config="datePickerStartOptions" v-model="activeEvent.startDate" ref="datePickerStart" :disabled="(apoId != null && currentKey != 'PHARMACYSERVICES')"></flat-pickr>
								</div>
							</div>

							<div class="control">
								<div class="control-label"><label-name labelKey="CALENDAR-EVENT-ENDDATE"></label-name></div>
								<div class="control">
									<flat-pickr placeholder="Enddatum" :config="datePickerEndOptions" v-model="activeEvent.endDate" ref="datePickerEnd" :disabled="(apoId != null && currentKey != 'PHARMACYSERVICES')"></flat-pickr>
								</div>
							</div>

		                </div>

						<!-- COMMON DATE -->
						<template v-if="currentCalendarEntryType == 'DEFAULT'">

							<!-- DESCRIPTION -->
							<form-input inputType="textarea" textareaMaxLength="200" label="CALENDAR-EVENT-DESCRIPTION" minWidth="200px" :showLabelInOptions="true" :showLabel="true" v-model="activeEvent.description" :isHorizontal="false" :isReadOnly="(apoId != null && currentKey != 'PHARMACYSERVICES')"></form-input>

							<!-- TODOS -->
							<template v-if="modal.type != 'eventAdd'">

								<div class="title is-5">todos (optional)</div>

								<!-- { 'is-disabled': apoId != null && todo.site != apoId } -->
								<div v-for="(todo, i) in activeEvent.tasks" :class="['todoBlock', { err: taskErrors.indexOf(i) > -1 }]" v-if="apoId == null || (apoId != null && todo.site == apoId)">

									<form-input inputType="text" label="CALENDAR-EVENT-TODO-TITLE" minWidth="200px" :showLabelInOptions="true" :showLabel="true" v-model="todo.title" :isHorizontal="false"></form-input>

									<div class="control is-grouped">

										<!-- <template v-if="activeUser.userRole.name != 'Apotheke'"> -->
										<template v-if="apoId == null">
											<form-input inputType="select" label="CALENDAR-EVENT-TODO-ASSIGNEE" selectOpenDirection="above" :showLabelInOptions="false" :showLabel="true" :selectOptions="todoAssigneeOptions" :selectAllowEmpty="false" v-model="todo.assignee" :isHorizontal="false"></form-input>
										</template>

										<div class="control">
											<div class="control-label"><label-name labelKey="CALENDAR-EVENT-TODO-DATE"></label-name></div>
											<div class="control">
												<flat-pickr placeholder="Datum" :config="datePickerOptions" v-model="todo.deadline" ref="datePickerTodo"></flat-pickr>
											</div>
										</div>

									</div>

									<!-- delete todo -->
									<pop-confirm class="todoDelete has-pointer" title="Todo löschen" content="Sind Sie sicher, dass Sie dieses Todo löschen wollen?" icon="question-circle-o" :on-ok="function() { todoDelete(todo, i) }" cancel-text="nein" ok-text="löschen">
										<span class="icon is-small">
											<i class="icon-ak-entfernen"></i>
										</span>
				                    </pop-confirm>

								</div>

								<span class="button is-small" @click="todoAdd()" v-if="!activeEvent.tasks || (activeEvent.tasks && activeEvent.tasks.length < 5)">
									<span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span>
									<span>todo hinzufügen</span>
								</span>

							</template>

						</template>

						<!-- SPECIAL DATE -->
						<template v-else>
							<checkbox v-model="activeEvent.showInCommunicationPlatform" :val="!activeEvent.showInCommunicationPlatform" :checked="activeEvent.showInCommunicationPlatform"><lang labelKey="CALENDAR-EVENT-SHOW_IN_COMMUNICATION_PLATFORM"></lang></checkbox>
						</template>

					</template>

				</div>

            </template>

			<template v-else>

				<template v-if="modal.type == 'channelEdit'">

					<form-input inputType="text" label="CHANNEL-TITLE" minWidth="200px" :showLabel="true" v-model="activeChannel.name" :isHorizontal="false"></form-input>

					<div class="control wide" style="min-width: 200px !important;">
						<div class="control-label">
							<label for="CHANNEL-COLOR" class="label">
								<lang labelKey="CHANNEL-COLOR"></lang>
							</label>
						</div>

						<div class="control">
							<input type="color" v-model="activeChannel.color" id="farbangabe" name="farbe" pattern="^#([A-Fa-f0-9]{6})$">
						</div>

					</div>

					<div class="control wide" style="min-width: 200px !important;">
						<div class="control-label">
							<label for="CHANNEL-TEXT-COLOR" class="label">
								<lang labelKey="CHANNEL-TEXT-COLOR"></lang>
							</label>
						</div>

						<div class="control">
							<input type="color" v-model="activeChannel.colorText" id="farbangabeText" name="farbeText" pattern="^#([A-Fa-f0-9]{6})$">
						</div>
					</div>


				</template>


			</template>



			<template slot="footer">

				<span :class="['button', { 'is-disabled': modal.isSaving}]" @click="closeModal(true)">abbrechen</span>

				<template v-if="modal.type == 'eventCopy'">
					<span :class="['button is-primary', { 'is-loading': modal.isSaving }]" @click="eventSaveCopy">speichern</span>
				</template>

				<template v-else-if="modal.type == 'channelEdit'">
					<span :class="['button is-primary', { 'is-loading': modal.isSaving }]" @click="channelSave">speichern</span>
				</template>

				<template v-else>
					<span :class="['button is-primary', { 'is-loading': modal.isSaving }]" @click="eventSave()">speichern</span>
				</template>

			</template>


        </modal>


    </div>
</div>

</template>


<script>
import flatPickr from 'vue-flatpickr-component';
import { de } from 'flatpickr/dist/l10n/de.js';
de.firstDayOfWeek = 1; // Monday

export default {

	components: {
		flatPickr
	},

	name: 'calendar',

    props: {

		pharmacy: {
			type: Object,
			default: null
		},

		isEmbedded: {
			type: Boolean,
			default: false
		},

		isPro: {
			type: Boolean,
			required: true,
			default: false
		},

		view: {
			type: String,
			default: 'year'
		}

    },

	data() {

		var self = this;

		return {

			site: null,

            showModal: false,
			showCategories: [],

			modal: {
				title: '',
				type: '',
				isSaving: false,
				isLoading: false
			},

			currentCalendarEntryType: null,
			currentKey: null,

			events: null,
			channels: [],
			pharmacies: [],
			marketingUsers: [],

			activeChannel: null,
			activeEvent: null,
			tmpEvent: null,

			pharmacyServiceChannelsSelected: null,
			marketingChannelSelected: null,
			selectedPharmacies: null,

			pharmaciesLoading: true,
			isLoading: true,
			isFetchingData: false,

			calendarView: 'year',

			date: new Date(),
            currentDate: new Date(),
            currentMonth: '',
            currentYear: '',

			currentColWidth: 0,
			currentColsWidth: 0,

            months: ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
			monthsShort: ['JAN', 'FEB', 'MÄR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'],


			datePickerStartOptions: {
				wrap: false,
                enableTime: false,
                altInput: true,
                altFormat: 'd.m.Y',
                locale: de,
				clickOpens: true,
                weekNumbers: true,
				minDate: null,
				maxDate: null,
				onOpen(selectedDates, dateStr, instance) {
					self.$set(self.datePickerEndOptions, 'minDate', dateStr);
		        },
		        onClose(selectedDates, dateStr, instance) {
					self.$set(self.datePickerEndOptions, 'minDate', dateStr);
		        }
            },

			datePickerEndOptions: {
                enableTime: false,
                altInput: true,
                altFormat: 'd.m.Y',
                locale: de,
				clickOpens: true,
                weekNumbers: true,
				minDate: null,
				maxDate: null,
				onStartChange(selectedDates, dateStr, instance) {
		         self.$set(self.datePickerStartOptions, 'maxDate', dateStr);
		        },
		        onEndChange(selectedDates, dateStr, instance) {
		          self.$set(self.datePickerStartOptions, 'maxDate', dateStr);
			  	}
            },

			datePickerOptions: {
                enableTime: false,
                altInput: true,
                altFormat: 'd.m.Y',
                locale: de,
				clickOpens: true,
                weekNumbers: true,
            },

			taskErrors: [],

			eventTopMargins: [],

			rowHeights: {}

		}
	},


    watch: {

        pharmacy(newVal, oldVal) {
			this.fetchData();
			this.site = newVal;
        },

		marketingChannelSelected(newVal) {

			if(newVal != null && newVal.name == 'GALLERIA') {
				this.fetchPharmacies();
			}

		},

    },


	computed: {

		apoId() {
			return this.site != null ? this.site.id : null;
		},

		calendarEntryTypes() {
			return this.$store.getters.getTermsByTaxonomy('CALENDAR_ENTRY_TYPES');
		},

		calendarEntryTaskResponsibilityTypes() {
			return this.$store.getters.getTermsByTaxonomy('CALENDAR_ENTRY_TASK_RESPONSIBILITY_TYPES');
		},

        currentDaysPerMonth() {
            return this.daysInMonth(this.currentMonth, this.currentYear);
        },

		currentDaysPerYear() {
			return new Date(this.currentYear,1,29).getDate() == 29 ? 366 : 365;
		},

		marketingChannels() {
			return this.$store.getters.getTermsByTaxonomy('MARKETING_CHANNELS');
		},

		pharmacyServiceChannels() {

			let channels = [];

			for(let key in this.marketingChannels) {


				if(this.marketingChannels[key].data.category == 'PHARMACYSERVICES') {

					if(key.substr(0, 24) != 'CUSTOM_MARKETING_CHANNEL' || (this.site.marketingChannelCustomizations != null && typeof this.site.marketingChannelCustomizations[key] != 'undefined' && this.site.marketingChannelCustomizations[key] !== false)) {

						channels.push({
							id: this.marketingChannels[key].id,
							name: this.getChannelCustomizationName(this.marketingChannels[key].name)
						})

					}

				}

			}

			return channels;

		},


        todoAssigneeOptions() {

			var res = [{
				id: 'SITE',
				type: 'SITE',
				name: this.apoId != null ? this.$t('CALENDAR_ENTRY_TASK_RESPONSIBILITY_SITE') : this.$t('CALENDAR_ENTRY_TASK_RESPONSIBILITY_SITES')
			}];

			this.marketingUsers.forEach(user => {

				res.push({
					id: user.id,
					type: 'USER',
					name: user.person != null ? user.person.fullName : user.username
				})

			})

			return res;

        },

		getEasterDate() {

			var y = this.currentYear;

	        var date, a, b, c, m, d;

	        // Instantiate the date object.
	        date = new Date;

	        // Set the timestamp to midnight.
	        date.setHours( 0, 0, 0, 0 );

	        // Set the year.
	        date.setFullYear( y );

	        // Find the golden number.
	        a = y % 19;

	        // Choose which version of the algorithm to use based on the given year.
	        b = ( 2200 <= y && y <= 2299 ) ?
	            ( ( 11 * a ) + 4 ) % 30 :
	            ( ( 11 * a ) + 5 ) % 30;

	        // Determine whether or not to compensate for the previous step.
	        c = ( ( b === 0 ) || ( b === 1 && a > 10 ) ) ?
	            ( b + 1 ) :
	            b;

	        // Use c first to find the month: April or March.
	        m = ( 1 <= c && c <= 19 ) ? 3 : 2;

	        // Then use c to find the full moon after the northward equinox.
	        d = ( 50 - c ) % 31;

	        // Mark the date of that full moon—the "Paschal" full moon.
	        date.setMonth( m, d );

	        // Count forward the number of days until the following Sunday (Easter).
	        date.setMonth( m, d + ( 7 - date.getDay() ) );

	        // Gregorian Western Easter Sunday
	        return date;

	    },

		optionsPharmacies() {

			let res = [];
			this.pharmacies.forEach(ph => {

				res.push({
					id: ph.id,
					name: ph.name,
					extRef: ph.extRef,
					displayName: ph.name + ' ('+ph.extRef+')',
					customLabel: ph.name + ' ('+ph.extRef+')'
				})

			})

			return res;

		},

	},

	created() {

		this.site = this.pharmacy;

        this.currentMonth = this.currentDate.getMonth();
        this.currentYear = this.currentDate.getFullYear();
		this.calendarView = this.view;

        this.fetchData();

	},

	mounted() {

        var self = this;

        this.$nextTick(function() {
            window.addEventListener('resize', function() {
				self.currentColsWidth = $('.cols').width();
				if(self.calendarView == 'month') {
					self.currentColWidth = $('.cols > .col').width();
				}
            });
        });

	},

    updated() {

		this.currentColsWidth = $('.cols').width();	// get the width of the .cols container

		if(this.calendarView == 'month') {
			this.currentColWidth = $('.cols > .col').width();	// get the width of the .cols > .col containers
		}

    },

	beforeDestroy() {

		// window.removeEventListener('resize', this.currentColWidth);
		// window.removeEventListener('resize', this.currentColsWidth);

	},

	methods: {

		toggleCategory(cat1,cat2) {

			let foundIndex = this.showCategories.indexOf(cat2);

			if(foundIndex == -1) {
				this.showCategories.push(cat2);
			} else {
				this.showCategories.splice(foundIndex, 1);
			}

			/*
			if(typeof this.events[cat1][cat2].show == 'undefined') {
				this.$set(this.events[cat1][cat2], 'show', true);
			}

			this.$set(this.events[cat1][cat2], 'show', !this.events[cat1][cat2].show);
			*/
		},

		showCategory(cat1,cat2) {

			return this.showCategories.indexOf(cat2) === -1;
			/*
			return typeof this.events[cat1][cat2].show != 'undefined' ? this.events[cat1][cat2].show : true;
			*/
		},

		channelEdit(key1, key2) {

			// console.log(key1, key2);

			this.activeChannel = {
				marketingChannel: key2,
				name: this.getChannelCustomizationName(key2),
				color: this.site.marketingChannelCustomizations != null && typeof this.site.marketingChannelCustomizations[key2] != 'undefined' && typeof this.site.marketingChannelCustomizations[key2].color != 'undefined' ? this.site.marketingChannelCustomizations[key2].color : '',
				colorText: this.site.marketingChannelCustomizations != null && typeof this.site.marketingChannelCustomizations[key2] != 'undefined' && typeof this.site.marketingChannelCustomizations[key2].colorText != 'undefined' ? this.site.marketingChannelCustomizations[key2].colorText : '',
			}

			this.modal.type = 'channelEdit';
			this.modal.title = 'Kanal "' + this.getChannelCustomizationName(key2) + '" bearbeiten';
			this.showModal = true;

		},

		channelAdd(key1) {

			this.activeChannel = {
				marketingChannel: null,
				name: '',
				color: '',
				colorText: ''
			}

			this.modal.type = 'channelEdit';
			this.modal.title = 'neuen Kanal anlegen';
			this.showModal = true;

		},

		channelDelete(key) {

			// Löschen: /api/site/[siteId]/deleteMarketingChannel { "marketingChannel": TERM_NAME }
			this.axios.post(this.$config.api + 'site/' + this.apoId + '/deleteMarketingChannel', { marketingChannel: key })
				.then(res => {

					this.axios.get(this.$config.api + 'site/'+this.site.id)
						.then(res => {

							this.updateSite(res.data);
							this.fetchData();

							this.$notify.open({ content: 'Kanal wurde erfolgreich entfernt!', type: 'success' });

							this.closeModal();

						});


				})

		},

		channelSave() {

			if(this.activeChannel.name.trim() == "") {
				this.$notify.open({ content: 'Bitte geben Sie einen Namen für den Channel ein!', type: 'warning' });
				return;
			}

			this.modal.isSaving = true;

			let saveObj = {
				name: this.activeChannel.name,
				color: this.activeChannel.color,
				colorText: this.activeChannel.colorText,
			}

			let msg = "";
			let type = "";

			if(this.activeChannel.marketingChannel != null) {

				saveObj.marketingChannel = this.activeChannel.marketingChannel;
				type = 'updateMarketingChannel';
				msg = 'Kanal wurde erfolgreich aktualisiert!';

			} else {

				type = 'createMarketingChannel';
				msg = 'Kanal wurde erfolgreich angelegt!';

			}


			this.axios.post(this.$config.api + 'site/' + this.apoId + '/'+type, saveObj)
				.then(res => {

					this.axios.get(this.$config.api + 'site/'+this.site.id)
						.then(res => {

							this.$store.dispatch('fetchTaxonomies').then(() => {

								this.updateSite(res.data);
								this.fetchData();
								this.$notify.open({ content: msg, type: 'success' });
								this.closeModal();

							})

						});

				})

		},


		formatEventDescription(description) {

			if(description == "") {
				return "";
			}

			let arr = description.split('<br />').map(el => el.replace(/<[^>]*>?/gm, ''));
			return arr.join("<br />");

		},

		updateSite(data) {

			this.site = data;

			// make sure to update store and localStorage if activeUser is a pharmacy
			if(this.activeUser.userRole.name == 'Apotheke') {

				let user = this.activeUser;
				user.site = data;

				this.$store.commit('setUser', user);
				localStorage.setItem('user', JSON.stringify(user));

			}

		},

		showChannel(key, channel) {

			// wenn nicht pharmacyservices oder site.marketingChannelCustomizations == null, alles normal anzeigen
			if(key != 'PHARMACYSERVICES' || this.site.marketingChannelCustomizations == null) {
				return true;
			}

			// 	wenn site.marketingChannelCustomizations[CHANNEL] = false, Channel nicht anzeigen
			if(channel.substr(0, 24) == 'CUSTOM_MARKETING_CHANNEL' && (!this.site.marketingChannelCustomizations[channel] || this.site.marketingChannelCustomizations[channel] && this.site.marketingChannelCustomizations[channel] === false)) {
				return false;
			}

			return true;

		},

		getChannelCustomizationName(channel) {

			// wenn site.marketingChannelCustomizations[TERM_NAME].name, diesen Namen anstelle des Labels verwenden
			if(this.site.marketingChannelCustomizations != null && typeof this.site.marketingChannelCustomizations[channel] != 'undefined' && typeof this.site.marketingChannelCustomizations[channel].name != 'undefined') {
				return this.site.marketingChannelCustomizations[channel].name;
			} else {
				return this.$t('TERM_MARKETING_CHANNELS-'+channel);
			}

		},

		/*
		getChannelCustomizationColor(channel) {

			// wenn site.marketingChannelCustomizations[TERM_NAME].color, diese Farbe anstelle der Farbe verwenden
			if(this.site.marketingChannelCustomizations != null && typeof this.site.marketingChannelCustomizations[channel] != 'undefined' && typeof this.site.marketingChannelCustomizations[channel].color != 'undefined') {
				return this.site.marketingChannelCustomizations[channel].color;
			} else {
				return channel;
			}

		},

		getChannelCustomizationColorText(channel) {

			// wenn site.marketingChannelCustomizations[TERM_NAME].colorText, diese Farbe anstelle der Farbe verwenden
			if(this.site.marketingChannelCustomizations != null && typeof this.site.marketingChannelCustomizations[channel] != 'undefined' && typeof this.site.marketingChannelCustomizations[channel].colorText != 'undefined') {
				return this.site.marketingChannelCustomizations[channel].colorText;
			} else {
				return channel;
			}

		},
		*/

		getRowHeight(key) {

			// console.log("key rowHeight: ", key);
			let n = this.rowHeights[key];

			let m = 8; 	// genereller abstand oben und unten
			let y = 2;	// abstand zum oberen event
			let x = 22; // event height

			/* n*x + (n-1)*y + m */
			return "height: " + (n*x + (n-1) * y + m) + 'px';

		},

		getEvents(events, channelName) {

			if(events == null) {

				return this.events['INACTIVE']['HERBASERVICES'][channelName];

			} else {

				return events;

			}

			return events;

		},

		calculateColWidth(month) {

			let width = (this.currentColsWidth / this.currentDaysPerYear * this.daysInMonth(month-1, this.currentYear) ) * 100 / this.currentColsWidth;
			return "width: "+width+"%";

		},


		todoDelete(todo, i) {

			this.activeEvent.tasks.splice(i,1);

		},

		todoAdd() {

			this.activeEvent.tasks.push(
				{
					calendarEntry: this.activeEvent.id,
					responsibilityType: null,
					assignee: null,
					deadline: null,
					title: '',
					isCompleted: false,
					site: this.apoId
				}
			)

		},

		eventAdd(key1, key2) {


			this.currentCalendarEntryType = key1;
			this.currentKey = key2;

			// empty the channels array
			this.channels = [];
			this.pharmacyServiceChannelsSelected = [];
			this.marketingChannelSelected = null;

			var self = this;

			Object.keys(this.events[key1][key2])
				.forEach(ch => {
					this.channels.push({ name: ch });
				})


			if(key1 == 'DEFAULT') {

				this.activeEvent = {
					startDate: null,
					endDate: null,
					title: '',
					description: '',
					site: this.apoId,
					type: this.calendarEntryTypes[this.currentCalendarEntryType],
					marketingChannel: null,
					tasks: [],
				}

			}
			else if(key1 == 'SPECIAL_DATE') {

				this.activeEvent = {
					startDate: null,
					endDate: null,
					title: '',
					description: '',
					site: null,
					type: this.calendarEntryTypes[this.currentKey],
					marketingChannel: null,
					showInCommunicationPlatform: false,
					tasks: [],
				}

			}

			this.modal.type = 'eventAdd';
			this.modal.title = 'Neuen Beitrag anlegen';
			this.showModal = true;

		},



		eventCopy(key, event) {

			this.currentKey = key;

			this.modal.type = "eventCopy";
			this.modal.title = "Event kopieren";

			this.tmpEvent = null;
			this.tmpEvent = JSON.parse(JSON.stringify(event));

			this.activeEvent = event;

			this.showModal = true;

		},


		eventEdit(type, event) {

			this.currentCalendarEntryType = type;

			if(this.currentCalendarEntryType == 'SPECIAL_DATE') {
				this.currentKey = 'SPECIAL_DATE';
			} else {
				this.currentKey = event.marketingChannel.data.category;
			}

			this.modal.type = 'eventEdit';
			this.modal.title = 'Eintrag bearbeiten';

			this.tmpEvent = null;
			this.tmpEvent = JSON.parse(JSON.stringify(event));

			this.activeEvent = event;

			// this.activeEvent.description = this.formatEventDescription(event.description);

			var self = this;


			if(this.activeEvent.tasks && this.activeEvent.tasks.length > 0) {

				this.activeEvent.tasks.forEach(task => {

					if(task.responsibilityType.name == 'SITE') {

						task.assignee = {
							id: 'SITE',
							type: 'SITE',
							name: event.site != null ? self.$t('CALENDAR_ENTRY_TASK_RESPONSIBILITY_SITE') : self.$t('CALENDAR_ENTRY_TASK_RESPONSIBILITY_SITES')
						}

					} else {

						let user = self.marketingUsers.find(user => user.id == task.assignee);

						task.assignee = {
							id: task.assignee,
							type: 'USER',
							name: user.person != null ? user.person.fullName : user.username
						}

					}

				})

			} else {

				this.$set(this.activeEvent, 'tasks', []);
				// this.activeEvent.tasks = [];

			}

            this.showModal = true;

		},

		eventDelete(event) {

			var self = this;

			this.entityDelete('calendarEntry', event.id, 'CALENDAR-EVENT-DELETE-CONFIRMATION')
				.then(function(response) { self.fetchData(); });

		},

		closeModal(revert=false) {

			// if the event needs to be reverted (user canceled the edit process ...)
			if(revert && this.modal.type != 'eventAdd') {

				var self = this;

				// revert for "SPECIAL DATES"
				if(this.currentCalendarEntryType == 'SPECIAL_DATE') {

					var foundIndex = this.events[this.currentCalendarEntryType][this.currentCalendarEntryType][this.activeEvent.type.name].findIndex((el) => {
						return el.id == self.activeEvent.id;
					});

					this.events[this.currentCalendarEntryType][this.currentCalendarEntryType][this.activeEvent.type.name][foundIndex] = this.tmpEvent;

				// revert for "DEFAULT DATES"
				} else {

					if(this.activeEvent != null && this.activeEvent.marketingChannel != null) {

						var foundIndex = this.events[this.activeEvent.type.name][this.activeEvent.marketingChannel.data.category][this.activeEvent.marketingChannel.name].findIndex(el => el.id == self.activeEvent.id);
						this.events[this.activeEvent.type.name][this.activeEvent.marketingChannel.data.category][this.activeEvent.marketingChannel.name][foundIndex] = this.tmpEvent;

					}

				}

			}

			this.modal.isSaving = false;
			this.pharmacies = null;
			this.pharmacyServiceChannelsSelected = [];
			this.selectedPharmacies = null;
			this.tmpEvent = null;
			this.activeChannel = {};
			this.activeEvent = null;
			this.modal = {
				title: '',
				type: '',
				isLoading: false,
				isSaving: false,
			};

			this.showModal=false;

		},

		eventSaveCopy() {

			if(this.pharmacyServiceChannelsSelected.length == 0) {
				this.$notify.open({ content: 'Bitte geben Sie Kanäle an, auf die das Event kopiert werden soll!', type: 'warning'});
				return;
			}

			this.modal.isSaving = true;

			this.axios.post(this.$config.api + 'calendarEntry/'+this.activeEvent.id+'/copy', { channels:  this.pharmacyServiceChannelsSelected.map(ch => ch.id) })
				.then(res => {

					this.$notify.open({ content: 'Event wurde erfolgreich kopiert', type: 'success'});
					this.fetchData();
					this.closeModal();

				})

		},


        eventSave() {


			// validate must have fields
			if(typeof this.activeEvent.id == 'undefined') {
				if(this.marketingChannelSelected == null && this.pharmacyServiceChannelsSelected.length == 0) {
			   		this.$notify.open({ content: 'Bitte wählen Sie einen Typ!', type: 'warning' });
				   	return;
				}
		   	}

			if(this.apoId == null && this.marketingChannelSelected != null && this.marketingChannelSelected.name == 'GALLERIA' && this.selectedPharmacies == null) {
				this.$notify.open({ content: 'Bitte wählen Sie eine Apotheke aus!', type: 'warning' });
				return;
			}

			if(this.activeEvent.title == null || this.activeEvent.title == "") {
				this.$notify.open({ content: 'Bitte geben Sie einen Titel ein!', type: 'warning' });
				return;
			}
			if(this.activeEvent.startDate == null || this.activeEvent.startDate == "") {
				this.$notify.open({ content: 'Bitte geben Sie ein Startdatum ein!', type: 'warning' });
				return;
			}
			if(this.activeEvent.endDate == null || this.activeEvent.endDate == "") {
				this.$notify.open({ content: 'Bitte geben Sie ein Enddatum ein!', type: 'warning' });
				return;
			}

			// format START and END date
			var startDate = new Date(this.activeEvent.startDate);
			startDate.setHours(0);
			startDate.setMinutes(0 - startDate.getTimezoneOffset());

			var endDate = new Date(this.activeEvent.endDate);
			endDate.setHours(23);
			endDate.setMinutes(59);
			endDate.setSeconds(59);

			this.activeEvent.startDate = startDate.toISOString();
			this.activeEvent.endDate = endDate.toISOString();

			var self = this;
			var galleriaSites = [];


			// new entry
			if(typeof self.activeEvent.id == 'undefined') {

				// in case of 'galleria' -> pharmacy was selected
				/*
				if(this.selectedPharmaies != null) {
					this.activeEvent.site = this.selectedPharmacies;
				}
				*/

				// DEFAULT DATES
				if(self.currentCalendarEntryType == "DEFAULT") {

					this.activeEvent.type = self.calendarEntryTypes[self.currentCalendarEntryType];

					if(this.currentKey == 'PHARMACYSERVICES') {
						this.activeEvent.marketingChannel = this.pharmacyServiceChannelsSelected.map(ch => ch.id);
					} else {
						this.activeEvent.marketingChannel = self.marketingChannels[self.marketingChannelSelected.name];
					}

					if(this.apoId !== null) {
						this.activeEvent.site = this.apoId;
					}

				// SPECIAL DATES
				} else {

					this.activeEvent.site = null;
					this.activeEvent.type = self.calendarEntryTypes[self.marketingChannelSelected.name];
					this.activeEvent.marketingChannel = null;

				}

			}

			this.taskErrors = [];

			// edit tasks (/todos)
			if(this.activeEvent.tasks && this.activeEvent.tasks.length > 0) {

				// validate tasks fields ... (returns true if a problem was found)
				let isError = this.activeEvent.tasks.some(function(t, index) {

					// if no deadline was given, push the index of the task into the "taskErrors" array
					if(t.deadline == null || t.deadline == '') {
						self.taskErrors.push(index);
						return true;
					}

				});

				if(isError === true) {
					this.$notify.open({ content: 'Bitte wählen Sie ein Datum für das Todo!', type: 'warning' });
					return;
				}

				for (var x in this.activeEvent.tasks) {

					// if(this.activeUser.userRole.name == 'Apotheke' || this.apoId != null) {
					if(this.apoId != null) {

						this.activeEvent.tasks[x].assignee = null;
						this.activeEvent.tasks[x].responsibilityType = self.calendarEntryTaskResponsibilityTypes.SITE;

					} else {

						if(this.activeEvent.tasks[x].assignee == null || this.activeEvent.tasks[x].assignee == '') {
							this.$notify.open({ content: 'Bitte wählen Sie eine Zuordnung für das Todo!', type: 'warning' });
							return;
						}

						if(this.activeEvent.tasks[x].assignee.type == 'USER') {
							this.activeEvent.tasks[x].assignee = this.activeEvent.tasks[x].assignee.id;
							this.activeEvent.tasks[x].responsibilityType = self.calendarEntryTaskResponsibilityTypes.MARKETING;
						}

						else if(this.activeEvent.tasks[x].assignee.type == 'SITE') {
							this.activeEvent.tasks[x].assignee = null;
							this.activeEvent.tasks[x].responsibilityType = self.calendarEntryTaskResponsibilityTypes.SITE;
						}

					}

				}
			}

			this.modal.isSaving = true;


			// galleria -> selected pharmacies -> multiple post requests (for each pharmacy)
			if(this.selectedPharmacies != null) {

				let promises = [];

				for(var key in this.selectedPharmacies) {
					// console.log("site: ", this.selectedPharmacies[key]);
					var saveObj = JSON.parse(JSON.stringify(this.activeEvent));
					saveObj.site = this.selectedPharmacies[key];
					promises.push(this.axios.post(this.$config.api + 'calendarEntry', saveObj))

				}

				Promise.all(promises)
					.then(responses =>  {

						console.log("responses: ", responses);

						this.modal.isSaving = false;
						this.closeModal();
						this.$notify.open({ content: 'Event wurde erfolgreich angelegt', type: 'success'});
						this.fetchData();

				  	});

			// default save
			} else {

				this.entityCreateOrUpdate('calendarEntry', this.activeEvent)
				.then(function(response) {
					self.closeModal();
					self.fetchData();
				});

			}

        },


		isDateHoliday(year, month, day) {

			var selectedDate = new Date(year, month, day);

			// if day is saturday or sunday
			if([0,6].indexOf(selectedDate.getDay()) > -1) {
				return true;
			}

			// check for fixed holiday days
			let dateStr = month+1 + '-' + day;
			if(['1-1', '1-6', '5-1', '8-15', '10-26', '11-1', '12-8', '12-24', '12-25', '12-26', '12-31'].indexOf(dateStr) > -1) {
				return true;
			}

			// variable holidays
			var holidays = [
				Number(this._addDays(this.getEasterDate, 1)),	// ostermontag
				Number(this._addDays(this.getEasterDate, 39)),	// christi himmelfahrt
				Number(this._addDays(this.getEasterDate, 50)),	// pfingsmontag
				Number(this._addDays(this.getEasterDate, 60))	// fronleichnam
			];

			if(holidays.indexOf(Number(selectedDate)) > -1) {
				return true;
			}

			return false;

		},

		_addDays(date, days) {
			var result = new Date(date);
			result.setDate(result.getDate() + days);
			return result;
		},

        daysInMonth(m, y) { // m is 0 indexed: 0-11

            switch (m) {
                case 1 :
                    return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
                case 8 : case 3 : case 5 : case 10 :
                    return 30;
                default :
                    return 31
            }

        },

        nav(next) {

            if(this.calendarView == 'month') {

                if(next == true) {

                    if(this.currentMonth == 11) {
                        this.currentMonth = 0;
                        this.currentYear += 1;
                    } else {
                        this.currentMonth += 1;
                    }

                } else {

                    if(this.currentMonth == 0) {
                        this.currentMonth = 11;
                        this.currentYear -= 1;
                    } else {
                        this.currentMonth -= 1;
                    }

                }

            } else {

                this.currentYear = (next == true) ? this.currentYear + 1 : this.currentYear -1;

            }

            this.fetchData();

        },

        changeCalendarView(type) {

            this.calendarView = type;
            this.fetchData();

        },

		goToMonth(n) {

            this.calendarView = 'month';
            this.currentMonth = (n-1);
			this.fetchData();

        },


        getEventPosition(event, type='default', rows=0) {

			var topMargin = 0;

			// TASK EVENT
			if(type == 'todo') {

				let marginTop = 0;
				let marginLeft = 0;

				// calculate the top margin
				if(rows > 0) {

					let y = 2;	// abstand zum oberen event
					let x = 22; // event height

					marginTop = (rows*x + rows*y) -4;

				} else {

					marginTop = -4;

				}

				if(this.calendarView == 'year') {
					marginLeft = (this._calculateOffset(event.deadline) - 2);
				} else {
					marginLeft = (this._calculateOffset(event.deadline) + (this.currentColWidth/2) - 5);
				}

				// return 'left: ' + marginLeft+'px !important;';
				return 'left: ' + marginLeft+'px !important; top: ' + marginTop+'px !important;';
			}

			// DEFAULT EVENT
			else if(type == 'default') {

				topMargin = event.row*24;

				let bgColor = "";
				let colorText = "";

				if(event.marketingChannel != null && event.marketingChannel.data != null) {

					if(event.marketingChannel.data.category == 'PHARMACYSERVICES' && this.site.marketingChannelCustomizations != null
						&& typeof this.site.marketingChannelCustomizations[event.marketingChannel.name] != 'undefined'
						&& this.site.marketingChannelCustomizations[event.marketingChannel.name].color != ''
						&& this.site.marketingChannelCustomizations[event.marketingChannel.name].color != null) {

							bgColor = this.site.marketingChannelCustomizations[event.marketingChannel.name].color;

					} else {

						bgColor = event.marketingChannel.data.color ? event.marketingChannel.data.color : '#DDD';

					}

					if(event.marketingChannel.data.category == 'PHARMACYSERVICES' && this.site.marketingChannelCustomizations != null
						&& typeof this.site.marketingChannelCustomizations[event.marketingChannel.name] != 'undefined'
						&& this.site.marketingChannelCustomizations[event.marketingChannel.name].colorText != ''
						&& this.site.marketingChannelCustomizations[event.marketingChannel.name].colorText != null) {

							colorText = this.site.marketingChannelCustomizations[event.marketingChannel.name].colorText;

					} else {

						colorText = event.marketingChannel.data.colorText ? event.marketingChannel.data.colorText : '#FFF';

					}


				} else {

					if(event.marketingChannel != null) {
						// console.log("marketingChannel: ", event.marketingChannel);
						bgColor = event.marketingChannel.data != null && event.marketingChannel.data.color && event.marketingChannel.data.color != null ? event.marketingChannel.data.color : '#DDD';
						colorText = event.marketingChannel.data != null && event.marketingChannel.data.colorText && event.marketingChannel.data.colorText != null ? event.marketingChannel.data.colorText : '#FFF';
					} else {
						bgColor = event.type.data != null ? event.type.data.color : '#DDD';
						colorText = event.type.data != null ? event.type.data.colorText : '#FFF';
					}

				}



				// note: the +1 and/or -1 reflect the border within the columns
	            // they make sure that the event nicely fits in a column
				let widthOffset = this.calendarView == 'year' ? 0 : 1;

				if(typeof event.startDisplayDate == 'undefined') {
					event.startDisplayDate = event.startDate;
				}

				return 'top: '+topMargin+'px; left: '+this._calculateOffset(event.startDisplayDate)+'px; width: '+(this._getDaysBetween(event.startDisplayDate, event.endDisplayDate) - widthOffset)+'px; background-color: ' + bgColor + '; color: ' + colorText + ';';

			}

        },

        _calculateOffset(date) {

			let millisecondsPerDay = 86400000; // 24 * 60 * 60 * 1000;

			if(this.calendarView == 'year') {

				return (((new Date(date) - new Date(this.currentYear, 0, 1) ) / millisecondsPerDay * this.currentColsWidth ) / this.currentDaysPerYear);

			} else {

				return (new Date(date) - new Date(this.currentYear, this.currentMonth, 1) ) / millisecondsPerDay * this.currentColWidth;

			}

        },

		_getDaysBetween(startDate, endDate) {

            let millisecondsPerDay = 86400000; // 24 * 60 * 60 * 1000;
			let timespan = (this._formatEndDate(endDate) - this._formatStartDate(startDate)) / millisecondsPerDay;

            if(this.calendarView == 'year') {

                return Math.round(timespan) * this.currentColsWidth / this.currentDaysPerYear;

            } else {

                return timespan * this.currentColWidth;

            }

        },

		_formatStartDate(date) {

			var d = new Date(date);
			d.setMinutes(0);
            d.setHours(0);
			d.setSeconds(0);
			return d;

		},

		_formatEndDate(date) {

			let d = new Date(date);
			d.setHours(23);
			d.setMinutes(59);
			d.setSeconds(59);

			return d;

		},

		inTimeSpan(task) {

			let date = new Date(task.deadline);

			return this.calendarView == 'year'
				? date.getFullYear() == this.currentYear
				: date.getMonth() == this.currentMonth;

		},

		getMarkerPosition(type) {

            let marginLeft = type=='year'
				? this._calculateOffset(this.date) + 4
            	: this.currentColWidth * this.date.getDate() - (this.currentColWidth /2);

			return 'left: ' + (180 + marginLeft) + 'px';

        },

		fetchData() {

			this.isFetchingData = true;

			var self = this;

            let url = this.calendarView == 'month'
                ? this.$config.api + 'calendarEntry/month?site='+self.apoId+'&month='+(self.currentMonth+1)+'&year='+self.currentYear+'&format=tree&v='+Date.now()+'&filters[communicationPlatform]=0'
                : this.$config.api + 'calendarEntry/year?site='+self.apoId+'&year='+self.currentYear+'&format=tree&v='+Date.now()+'&filters[communicationPlatform]=0'

            this.axios.get(url)
				.then(function(response) {

					for(var key in response.data) {

						for(var ch in response.data[key]) {

							for(var channel in response.data[key][ch]) {

								// helper array
								var h = [];

								if(response.data[key][ch][channel] == null) {
									continue;
								}


								response.data[key][ch][channel].forEach(i => {

									// console.log(i.startDate, i.startDisplayDate);
									// console.log(i.endDate, i.endDisplayDate);

									i.sd = new Date(i.startDate).getTime();
									i.ed = new Date(i.endDate).getTime();

									// i.sd = new Date(i.startDisplayDate).getTime();
									// i.ed =  new Date(i.endDisplayDate).getTime();

									// start: 2019-12-12
									// end: 2020-02-10

									for(let j = 0; j < h.length; j++) {

										if(!h[j].find(x => !(x.ed < i.sd || x.sd > i.ed))) {
											h[j].push(i);
											i.row = j;
											break;
										}

									}

									if (typeof i.row == 'undefined') {
										h.push([i]);
										i.row = h.length - 1;
									}

									self.rowHeights[channel] = h.length;

								});


							}

						}


					}

					self.events = response.data;

                    self.isLoading = false;
					self.isFetchingData = false;

				}).then(response => {

					if(!self.isEmbedded && self.marketingUsers.length == 0) {
						self.fetchMarketingUsers();
					}

				}).catch(function(error) {
					console.log('Error: ', error.message);
					self.isLoading = false;
				});

		},

		fetchPharmacies() {

			var self = this;
			this.pharmaciesLoading = true;

			this.axios.get(this.$config.api + 'site?filters[hasGalleria]=true&orderBy=name&fields=name,extRef,mandate')
				.then(function(response) {

					self.pharmacies = response.data.site;

					// if there already is a pharmacyId, the selectbox shall be pre-selected with this pharmacy
					if(self.apoId != null) {

						var foundPharmacy = self.pharmacies.find(pharmacy => pharmacy.id == self.apoId);

						if(foundPharmacy) {

							foundPharmacy.displayName = foundPharmacy.name + ' ('+foundPharmacy.extRef+')';
							foundPharmacy.customLabel = null;
							self.selectedPharmacies = foundPharmacy;

						}

					}

					self.pharmaciesLoading = false;

				});

		},

		fetchMarketingUsers() {

			this.axios.get(this.$config.api + 'calendarEntry/marketingUsers').then(res => this.marketingUsers = res.data);

		},

	}

}
</script>


<style scoped>


	/* CALENDAR INFO BOX
	-----------------------------------------------------------------------*/
	.calendarInfoBox {
		margin: 75px auto 25px auto;
		text-align: center;
		width: 100%;
		max-width: 1024px;
	}
	.calendarInfoBox .title {
		font-size: 18px !important;
		margin: 0 0 10px 0 !important;
	}
	.calendarInfoBox .text {
		font-size: 12px;
		line-height: 1rem;
	}
	.calendarInfoBox .text p {
		margin-bottom: 8px;
		white-space: normal;
	}


    /* CALENDAR
    -----------------------------------------------------------------------*/
    .calendar {
        position: relative;
        z-index: 0;
        margin: 0 auto;
        width: 98%;
        min-width: 800px;
    }

	/* calendar header */
	.calendar .calendarHeader {
		position: relative;
		width: auto;
		margin-left: 180px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 25px;
	}

	.calendar .calendarHeader .calendarNavi {
		display: flex;
		align-items: center;
		justify-content: center;
		width: auto;
	}
	.calendar .calendarHeader .calendarNavi .prev,
    .calendar .calendarHeader .calendarNavi .next {
        cursor: pointer;
        color: #aaa;
        transition: color .3s ease;
    }
    .calendar .calendarHeader .calendarNavi .prev:hover,
    .calendar .calendarHeader .calendarNavi .next:hover {
        cursor: pointer;
        color: #000;
    }
    .calendar .calendarHeader .calendarNavi .title {
        font-size: 18px;
		/*line-height: 48px; */
        text-transform: uppercase;
        margin: 0;
    }

	.calendar .calendarHeader .calendarSwitcher {
		position: absolute;
		right: 0;
	}


	/* calendar body */
	.calendar .calendarBody {
        position: relative;
        padding-top: 30px;
    }

	/* calendar current day marker */
    .calendarBody .currentDayMarker {
        position: absolute;
        z-index: 99;
        height: auto;
        top: 40px;
        bottom: -10px;
        border-right: 1px solid #666;
        margin-right: -1px;
    }


    /* calendar ROWS
    -----------------------------------------------------------------------*/
    .rows {
        position: relative;
        z-index: 2;
        width: 100%;
        overflow: hidden;
    }
    .rows .row {
        position: relative;
		z-index: 3;
        width: 100%;
        min-height: 24px;
        margin: 0;
        padding: 8px 0;
		padding: 0;
		min-height: 30px;
    }

    /* decent hover for rows */
	/*
    .rows .row:not(.category):hover {
        background-color: rgba(226,230,233,0.4);
    }
	*/

    /* bottom margin on last row, in order increase the bottom margin of the calendar */
    .rows .row:last-child {
        margin-bottom: 15px;
    }

	.rows .row .label {
        min-width: 100px;
        width: 180px;
        text-align: right;
        font-weight: normal;
        margin: 0;
        padding: 0 15px 0 0;
        font-size: 12px;
        overflow: hidden;

		padding: 4px 12px 0 0;
    }
	.rows .row .label .icon.is-small {
		vertical-align: middle;
		line-height: 14px;
		margin: 0 0 0 4px;
	}

	.rows .row .label .icon.toggler {
		float: left;
		line-height: inherit;
		margin: 0 !important;
	}

	.rows .row.inactive .label {
		color: #ababab !important;
	}

    .rows .row .events {
        position: absolute;
        left: 180px;
        right: 0;

        top: 0;
        bottom: 0;


		top: 4px;
    }


    .rows .row .events .event {
        position: absolute;
		z-index: 1;
		top: 8px;
		bottom: 8px;
        left: 0;
        font-size: 10px;
        text-align: center;
        color: #fff;
        overflow: hidden;
        border-radius: 3px;
        cursor: pointer;
		top: 0;
		bottom: auto;
		height: 22px;
		line-height: 22px;
    }

	.rows .row .events .event.inactive {
		/*pointer-events:none;*/
		background-color: lightgrey !important;
	}
    .rows .row .events .event .eventTitle {
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        width: auto;
        position: absolute;
        left: 0;
        right: 0;
        padding: 0 10px;
    }

	.rows .row .events .todo {
        position: absolute;
		z-index: 10;
        top: -6px !important;
        bottom: auto !important;
        min-width: 10px;
		width: 12px !important;
		height: 12px !important;

		/*background-color: red;*/
		background-color: #C10000;
    	left: 0;
        font-size: 10px;
        overflow: hidden;
        border-radius: 100px;
        cursor: pointer;
    }
	.rows .row .events .todo.isOrange {
		background-color: orange;
	}

	.rows .row .events .event,
	.rows .row .events .todo {
		/*
		-webkit-transition: opacity .2s ease-in-out;
		-moz-transition: opacity .2s ease-in-out;
		-ms-transition: opacity .2s ease-in-out;
		-o-transition: opacity .2s ease-in-out;
		transition: opacity .2s ease-in-out;
		*/
		transition: opacity .2s ease;
	}
	.rows .row .events .event:hover,
	.rows .row .events .todo:hover {
		zoom: 1;
	    filter: alpha(opacity=75);
	    opacity: 0.75;
	}


	.rows .row.category {
		background: #FFF;
		margin: 0 0 10px 0;
	}
    .rows .row.category .label {
        font-weight: bold;
        font-size: 13px;
		/*
		display: flex;
		justify-content: flex-end;
	    align-items: center;
		*/
    }
	.rows .row.category .label .icon {
		margin-left: 5px;
	}

	.rows .row:not(.category):nth-child(odd) {
		background-color: rgba(226,230,233,0.4);
	}


    /* calendar COLS
    -----------------------------------------------------------------------*/
    .cols {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        align-items: stretch;

        position: absolute;
        z-index:0;
        left: 180px;
        top: 0;
        bottom: 0;
        right: 0;
    }
    .cols .col {
        min-width: 20px;
        position: relative;
    }
	.cols .col.day {
        flex-grow: 1;
		flex-basis: 0;
        min-width: 20px;
        position: relative;
	}
    .cols .col .head {
        text-align: center;
        font-size: 11px;
        color: #888;
        padding: 0;
    }
    .cols .col .body {
        position: absolute;
        top: 30px;
        bottom: 0;
        left: 0;
        right: 0;
        width: auto;
        border-right: 1px solid #e2e6e9;
    }
    .cols .col:first-child .body {
        border-left: 1px solid #e2e6e9;
    }
    .cols .col .body.isWeekend {
        background: #f6f7fb !important;
    }

	/* popover calendar item */
	.popover-content .calendarPopover {
		font-size: 11px;
	}
	.popover-content .calendarPopover .block {
		padding: 8px 14px !important;
		margin: 0 -8px;
		border-bottom: 1px solid #ddd;
		margin-bottom: 2px;
	}
	.popover-content .calendarPopover .block:last-child {
		border-bottom: none;
	}

	/*
	.popover-content .calendarPopover .block .edit {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	*/

	.popover-content .calendarPopover .block .edit .icon.is-small {
		font-size: 12px;
	    height: 14px;
	    line-height: 14px;
	    width: 14px;
		transition: color .3s ease;
		color: #aaa;
	}
	.popover-content .calendarPopover .block .edit .icon.is-small:not(:last-child) {
		margin-right: 3px;
	}
	.popover-content .calendarPopover .block .edit .icon.is-small:hover {
		color: #222;
	}


	.popover-content .calendarPopover .channel {
		text-transform: uppercase;
		font-size: 9px;
		color: #aaa;
		display: block;
		margin-bottom: 2px;
	}
	.popover-content .calendarPopover .title {
		font-size: 11px;
		font-weight: bold;
		display: block;
		line-height: 1.1rem;
		margin-bottom: 2px;
	}
	.popover-content .calendarPopover .description {
		font-size: 11px;
		display: block;
		line-height: 1.1rem;
		margin-bottom: 2px;
	}

	.popover-content .calendarPopover .tasks .taskDate {
		display: inline-block;
		width: 65px;
		font-size: 11px;
	}



	/* popover label item */
	.popover-content .labelPopover .title {
		text-transform: uppercase;
		color: #222;
		font-weight: bold;
		font-size: 11px;
		margin-bottom: 4px;
	}
	.popover-content .labelPopover .infoText {
		font-size: 11px;
		line-height: .9rem;
		display: block;
	}

	>>> .modal-card-body {
		overflow-y: auto !important;
	}

	.modal.eventCopy >>> .modal-card-body {
		overflow-y: visible !important;
	}

	.pharmacyServiceChannels >>> .multiselect__input {
		display: none !important;
	}


	.modal-card-body .title.is-5 {
		font-size: 12px;
		font-weight: bold;
		text-transform: uppercase;
		margin: 15px 0 8px 0;
	}
	.todoBlock {
		position: relative;
		padding: 10px 8px;
		margin-bottom: 8px;
		background: #F5F5F5;
		border-radius: 2px;
		border: 1px solid #F5F5F5;
	}
	.todoBlock.err {
		border-color: #ff9191;
	}
	.todoBlock:last-child {
		margin-bottom: 0;
	}

	.todoBlock >>> .control:last-of-type {
		margin-bottom: 0;
	}

	.todoDelete {
		position: absolute;
		right: -24px;
		top: 10px;
		width: 24px;
		height: 24px;
		display: flex;
	    justify-content: center;
	    align-items: center;
		background-color: #f5f5f5;
		border-top-right-radius: 2px;
		border-bottom-right-radius: 2px;
	}
	.todoDelete .icon {
		font-size: 12px;
		height: 14px;
		line-height: 14px;
		width: 14px;
		color: #aaa;
		transition: color .3s ease;
	}
	.todoDelete:hover .icon {
		color: #000;
	}


	>>> .control > .control {
		min-width: 150px;
		max-width: 100%;
	}
	>>> .control .input[readonly] {
		background-color: #FFF !important;
	}








</style>

<style lang="scss">

	.icon.is-smaller {

		width: 14px;
		height: 18px;
		line-height: 18px;
		margin: 0 !important;

		i {
			font-size: 10px;

		}

		&:hover {
			i {
				color: #aaa;
			}
		}

	}

	.label {

		.labelEditable {
			transition: color .3s ease;
			cursor: pointer;

			&:hover {
				color: #aaa;

				i {
					color: #aaa;
				}
			}

		}

	}

	.labelAddChannel {
		font-size: 10px;
		cursor: pointer;
		text-align: right;
		font-weight: normal;
		/*text-transform: uppercase;*/
	}


	.overlayLoader {
		position: absolute;
		z-index: 9999;
		background: rgba(255,255,255,.8);
		top: 0;
		left: 0; right: 0;
		bottom: 0;
	}

	.tab-content {

		.downloadInfo {

			display: inline;
			border: none !important;
			border-radius: 0;
			padding: 0 !important;
			margin: 0 !important;
			transition: color .3s ease;
			color: #222;
			vertical-align: middle;

			&:hover {
				border: 0 !important;
				background: none !important;
				color: #000;
			}

			.icon {
				margin-right: 6px;
				vertical-align: initial;
			}
		}
	}

</style>

<style>
	.flatpickr-calendar .flatpickr-weekdaycontainer {
		width: 100% !important;
	}
	.popover-content .labelPopover .infoText a {
		color: #45A3D2 !important;
	}
</style>
